import React, { createContext, useContext, useState } from "react";
import { HeartHandshake } from "lucide-react";
import FeedbackModal from "@/components/FeedbackModal";

const FeedbackContext = createContext(null);

export function FeedbackProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openFeedback = () => setOpen(true);
  const closeFeedback = () => setOpen(false);

  return (
    <FeedbackContext.Provider value={{ openFeedback, closeFeedback }}>
      {children}

      {/* Persistent floating button on every page */}
      <button
        onClick={openFeedback}
        data-testid="feedback-fab"
        className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-[#4A5D4E] text-[#FDFBF7] text-sm font-medium shadow-lg hover:bg-[#3B4A3E] transition-all hover:-translate-y-0.5"
        title="Between Us is in development — we'd love your feedback"
      >
        <HeartHandshake className="h-4 w-4" strokeWidth={1.75} />
        Help us improve
      </button>

      {open && <FeedbackModal onClose={closeFeedback} />}
    </FeedbackContext.Provider>
  );
}

export const useFeedback = () => useContext(FeedbackContext);
